var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 16,
    r: 5.25,
    stroke: "#2F2F5B",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 22.4794C33.0798 22.2254 35.5 19.6453 35.5 16.5C35.5 13.3546 33.0798 10.7746 30 10.5205V13.0354C31.6961 13.278 33 14.7367 33 16.5C33 18.2632 31.6961 19.7219 30 19.9645V22.4794Z",
    fill: "#2F2F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 21.9589C10.4202 21.7049 8 19.1248 8 15.9795C8 12.8341 10.4202 10.2541 13.5 10V12.5149C11.8039 12.7575 10.5 14.2162 10.5 15.9795C10.5 17.7427 11.8039 19.2014 13.5 19.444V21.9589Z",
    fill: "#2F2F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 35.6914V31.4829C13 28.4548 15.4548 26 18.4829 26H25.6792C28.7073 26 31.1621 28.4548 31.1621 31.4829V35.6914",
    stroke: "#2F2F5B",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27.5C34 28 36 29.6154 36 33",
    stroke: "#2F2F5B",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27.5C10 28 8 29.6154 8 33",
    stroke: "#2F2F5B",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.f612b068.svg";
export { ForwardRef as ReactComponent };